export const severalSideTextEscapeString = '*$bs'
export const OFFICIAL_TIME_LIMIT = 90
export const TUTORIAL_TIME_LIMIT = 5
